import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_phs269hs3m: FaireBrandEntity = {
  token: "b_phs269hs3m",
  type: "brand",
  name: "Sundrop",
  avatarUrl:
    "https://cdn.faire.com/fastly/d5ea1bccd0f31242bb76ed31bc7bfeae19b8bf3feb276f51c7b5f07a8b6554fd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4295f3af6b0257809f2533e74a3bacd98db8ea6245632816e305a676474474fc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d5ea1bccd0f31242bb76ed31bc7bfeae19b8bf3feb276f51c7b5f07a8b6554fd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4295f3af6b0257809f2533e74a3bacd98db8ea6245632816e305a676474474fc.jpeg",
  location: "Wheat Ridge, CO, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 14,
  isInsider: true,
  description:
    "Shop Sundrop focuses on designing and crafting embroidered hats that serve as a canvas for self-expression. Each stitch reflecting the unique personality and style of its wearer. At Shop Sundrop, we believe that your accessories should speak to who you are, and our hats are designed to help you do just that—one thread at a time.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:19.108Z",
    importedBy: "entity-db-cli",
  },
};
